import { PureComponent } from "react";

import { TriggerButton } from "widgets";

import { pluralizeWord } from "../../app-utils/string.js";
import { type ITableData } from "../../redux/modules/table-data.js";
import PhenotypeEditingWizard from "../playbooks/phenotype/PhenotypeEditingWizard.js";

export interface IDataEntryButtonProps {
  activeTable: ITableData;
}

interface IDataEntryButtonState {
  showEditWizard: boolean;
}

/**
 * Button that allows to push a selection of organisms to the phenotype editing form
 *
 */
class DataEntryButton extends PureComponent<IDataEntryButtonProps, IDataEntryButtonState> {
  constructor(props: IDataEntryButtonProps) {
    super(props);
    this.state = { showEditWizard: false };
  }

  disabledTooltipText = () => {
    const table: ITableData = this.props.activeTable;
    const count: number = table.selectionModel.selectedIds.length || 0;

    if (count === 0) {
      return "At least one row must be selected to start the data entry";
    }
  };

  render() {
    const table: ITableData = this.props.activeTable;
    const disabledTooltip: string = this.disabledTooltipText();
    const count: number = table.selectionModel.selectedIds.length || 0;
    return (
      <>
        <TriggerButton
          key={"data-entry-btn-header"}
          isDisabled={disabledTooltip}
          icon={"edit"}
          tooltip={`Enter data for ${count} ${pluralizeWord("genome", count)}`}
          onPress={() => this.setState({ showEditWizard: true })}
          label={"Data Entry"}
          showLabel
        />
        {this.state.showEditWizard && (
          <PhenotypeEditingWizard
            tableSpec={this.props.activeTable.tableQuerySpec}
            onClose={() => this.setState({ showEditWizard: false })}
          />
        )}
      </>
    );
  }
}

export default DataEntryButton;
